// Team assignment (teamq, teamq_n, supervisor_of) is managed in the new app:
// Admin → Access Control → Team Assignments. These fields are read-only in this app
// (uv-api refuses the writes too).
export const TEAM_FIELDS = ['teamq', 'teamq_n', 'supervisor_of'];

export const TEAM_FIELDS_NOTE =
  'Team membership is managed in the new app: Admin → Access Control → Team Assignments.';

export const isTeamField = (name) => TEAM_FIELDS.includes(name);
